var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.16663C9.8995 5.16663 12.25 4.38312 12.25 3.41663C12.25 2.45013 9.8995 1.66663 7 1.66663C4.1005 1.66663 1.75 2.45013 1.75 3.41663C1.75 4.38312 4.1005 5.16663 7 5.16663Z",
    stroke: "#848491",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7.5C12.25 8.46833 9.91667 9.25 7 9.25C4.08333 9.25 1.75 8.46833 1.75 7.5",
    stroke: "#848491",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.41663V11.5833C1.75 12.5516 4.08333 13.3333 7 13.3333C9.91667 13.3333 12.25 12.5516 12.25 11.5833V3.41663",
    stroke: "#848491",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommission);
export default __webpack_public_path__ + "static/media/commission.cf138a0c2e946090098026d25844399c.svg";
export { ForwardRef as ReactComponent };